export const styles = (theme) => {
    const {
        miscellaneous: { spacing }
    } = theme;
    return {
        subtitle: {
            marginBottom: spacing * 2
        }
    };
};
